// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__qaOVx","selected":"Chip_selected__A2SOo"};